import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=496e6a2b&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=496e6a2b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e6a2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496e6a2b')) {
      api.createRecord('496e6a2b', component.options)
    } else {
      api.reload('496e6a2b', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=496e6a2b&scoped=true", function () {
      api.rerender('496e6a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/FileUpload.vue"
export default component.exports